const apiUrl = process.env.REACT_APP_API_URL;

export async function GetActivitatsUsuarisRecompenses(idActivitat: string) {
    const url = `${apiUrl}:8061/jutge/activitats/${idActivitat}/recompenses/usuaris`;
    try {
        const response = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('authToken') || localStorage.getItem('token')}`
            }
        });
        if (!response.ok) return [];
        return await response.json();
    } catch (e) {
        return [];
    }
}
